(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carlios-chi-sono"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initSun(root){
    if(!root || root.dataset.csReady === '1') return;
    root.dataset.csReady = '1';
    var s = root.querySelector('.cs-quote__sun');
    if(!s) return;
    var u = s.querySelector('use'); if(!u) return;
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var faces = ['carlios-cs-wink','carlios-cs-happy','carlios-cs-wink','carlios-cs-open'], i = 0;
    setInterval(function(){
      i = (i + 1) % faces.length;
      u.setAttribute('href', '#' + faces[i]);
    }, 2800);
  }
  function boot(){ Array.prototype.slice.call(document.querySelectorAll('.carlios-cs')).forEach(initSun); }
  if(document.readyState !== 'loading'){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
  document.addEventListener('shopify:section:load', function(e){
    var el = e.target && e.target.querySelector ? e.target.querySelector('.carlios-cs') : null;
    if(el){ el.dataset.csReady = ''; initSun(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carlios-diagnostica"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* ========================================================
     QUESTION BANK
     Q1–Q4 always fixed. Q5–Q6 dynamic: foundation or advanced,
     decided after Q4. Each question:
       key, label (receipt), pretty (ledger), text, sub,
       tags{si,no,ns}      → answer result label
       feedback{si,no,ns}  → end-screen diagnosis line
     ======================================================== */
  const Q = {
    /* ---------- CORE 4 (always shown, in this order) ---------- */
    f1: {
      key: 'f1_visibilita', label: 'VISIBILITÀ ORGANICA', pretty: 'Visibilità organica',
      pillar: true,
      text: `Quando qualcuno cerca su Google un prodotto o una categoria che vendi, senza cercare il tuo nome, esci <em>tu</em> o un concorrente<span class="qmk">?</span>`,
      sub:  `Pagine prodotto e categorie, non solo la home. Se ti trovano solo quando ti conoscono già, <em>stai pagando visibilità che potresti costruire.</em>`,
      tags: {
        si: `OK · TI TROVANO`,
        no: `PUNTO APERTO · VISIBILITÀ`,
        ns: `DA VERIFICARE · VISIBILITÀ`
      },
      feedback: {
        si: `Bene. Se esci anche su ricerche non di marca, porti a casa traffico che gli altri pagano.`,
        no: `Punto aperto pesante. Se compari solo quando ti cercano per nome, vivi di chi già ti conosce, e paghi per tutto il resto.`,
        ns: `Onesto. Quasi nessuno controlla le ricerche non di marca: è lì che si vede se il negozio esiste per Google o solo per te.`
      }
    },
    f2: {
      key: 'f2_scheda', label: 'SCHEDA PRODOTTO', pretty: 'Scheda prodotto',
      text: `Se un cliente arriva su una scheda prodotto <em>senza conoscerti</em>, trova abbastanza per comprare<span class="qmk">?</span>`,
      sub:  `Varianti, misure, materiali, compatibilità, tempi, dubbi. Una scheda debole <em>non si trova su Google e non chiude chi ci arriva.</em>`,
      tags: {
        si: `OK · SCHEDA CHE VENDE`,
        no: `PUNTO APERTO · SCHEDA DEBOLE`,
        ns: `DA VERIFICARE · SCHEDA`
      },
      feedback: {
        si: `Bene. Una scheda che risponde ai dubbi vende da sola e aiuta anche il posizionamento.`,
        no: `Qui si perde due volte: una scheda povera fatica su Google e non convince chi arriva freddo.`,
        ns: `Da guardare con occhi da cliente nuovo. Spesso ciò che per te è ovvio, per chi non ti conosce è un dubbio che blocca l'acquisto.`
      }
    },
    tracking: {
      key: 'tracking', label: 'TRACKING', pretty: 'Tracking',
      pillar: true,
      text: `GA4, pixel e Shopify ti danno <em>tre numeri diversi</em>. Sai quale credere<span class="qmk">?</span>`,
      sub:  `Tre fonti, tre storie. Se non sai quale dice la verità, <em>ottimizzi al buio.</em>`,
      tags: {
        si: `OK · NUMERI COERENTI`,
        no: `PUNTO APERTO · DATI INCOERENTI`,
        ns: `DA VERIFICARE · TRACKING`
      },
      feedback: {
        si: `Ottimo. Se sai quale fonte dice la verità, decidi in fretta e con meno nebbia.`,
        no: `Qui si ottimizza al buio. Senza una fonte affidabile è anche difficile capire quali canali portano margine e quali solo rumore.`,
        ns: `Da verificare. Quando le fonti non coincidono, il primo lavoro è capire chi sta mentendo, prima di toccare campagne o pagine.`
      }
    },
    customerCost: {
      key: 'customer_cost', label: 'COSTO CLIENTE', pretty: 'Costo cliente',
      text: `Sai quanto ti costa <em>portare un cliente</em><span class="qmk">?</span>`,
      sub:  `Costo cliente, costo per ordine, margine sul primo acquisto. <em>Con un numero che useresti in una riunione.</em>`,
      tags: {
        si: `OK · NUMERO NOTO`,
        no: `PUNTO APERTO · COSTO IGNOTO`,
        ns: `DA VERIFICARE · COSTO CLIENTE`
      },
      feedback: {
        si: `Ottimo. Se conosci il costo cliente, sai quanto spingere e dove fermarti, per canale.`,
        no: `Punto aperto serio. Senza questo numero, una campagna che sembra funzionare può mangiarti il margine senza che te ne accorga.`,
        ns: `Da verificare. Senza questi numeri, diventa difficile capire quali canali portano margine e quali solo rumore.`
      }
    },
    /* ---------- FOUNDATION finish (default route) ---------- */
    conversion: {
      key: 'conversione', label: 'CONVERSIONE', pretty: 'Conversione',
      text: `Sai quanti visitatori <em>comprano davvero</em>, e dove perdi gli altri<span class="qmk">?</span>`,
      sub:  `Tasso di conversione, punti morti, abbandoni. <em>Il traffico è inutile se il negozio non chiude.</em>`,
      tags: {
        si: `OK · CONVERSIONE NOTA`,
        no: `PUNTO APERTO · CONVERSIONE`,
        ns: `DA VERIFICARE · CONVERSIONE`
      },
      feedback: {
        si: `Bene. Se sai dove si fermano le persone, ogni euro di traffico rende di più.`,
        no: `Spesso il problema non è "poco traffico", è un negozio che non chiude: lì un punto recuperato vale più di mille click nuovi.`,
        ns: `Da verificare. Senza guardare dove si perdono i visitatori, si finisce per comprare più traffico per riempire un secchio bucato.`
      }
    },
    ownership: {
      key: 'ownership', label: 'PROPRIETÀ', pretty: 'Proprietà account',
      text: `I tuoi account, dati e accessi sono <em>davvero tuoi</em><span class="qmk">?</span>`,
      sub:  `Shopify, dominio, GA4, Ads, Meta, Klaviyo. <em>Se domani cambi fornitore, resti proprietario?</em>`,
      tags: {
        si: `OK · TUTTO TUO`,
        no: `PUNTO APERTO · RISCHIO LOCK-IN`,
        ns: `DA VERIFICARE · PROPRIETÀ`
      },
      feedback: {
        si: `Perfetto. Base sana: il sistema può crescere senza tenerti in ostaggio.`,
        no: `Punto aperto delicato. Se gli account non sono tuoi, non hai un sistema: hai un noleggio che qualcun altro può spegnere.`,
        ns: `Da verificare subito. Prima di costruire altro, devi sapere chi possiede accessi, dati e strumenti.`
      }
    },
    /* ---------- HARD finish (confident route, the bluff-call) ---------- */
    nextLever: {
      key: 'next_lever', label: 'PROSSIMA LEVA', pretty: 'Prossima leva',
      text: `Sai qual è la <em>prossima leva</em> che vale più soldi<span class="qmk">?</span>`,
      sub:  `Traffico, conversione, retention, margine. <em>Una priorità sola, difendibile coi numeri.</em>`,
      tags: {
        si: `OK · PRIORITÀ CHIARA`,
        no: `PUNTO APERTO · PRIORITÀ CONFUSA`,
        ns: `DA VERIFICARE · PROSSIMA LEVA`
      },
      feedback: {
        si: `Ottimo. Quando la prossima leva è chiara, il lavoro diventa preciso invece che dispersivo.`,
        no: `Spesso è qui il punto vero nei sistemi già avviati: non manca lavoro, manca una priorità che valga soldi.`,
        ns: `Da verificare. Se tutto sembra importante, il rischio è spendere energie su cose corrette ma non decisive.`
      }
    },
    dependency: {
      key: 'dependency', label: 'DIPENDENZA', pretty: 'Dipendenza',
      text: `Se sparisse chi gestisce il tuo marketing, sapresti <em>ripartire da solo</em><span class="qmk">?</span>`,
      sub:  `Strategia, accessi, logica delle campagne. <em>O il sistema vive nella testa di qualcun altro?</em>`,
      tags: {
        si: `OK · SISTEMA TUO`,
        no: `PUNTO APERTO · DIPENDENZA`,
        ns: `DA VERIFICARE · DIPENDENZA`
      },
      feedback: {
        si: `Bene. Il sistema vive nei tuoi strumenti e nei tuoi numeri, non solo in una persona.`,
        no: `Punto aperto ad alto rischio. Se tutto dipende da una testa sola, una partenza o un litigio ti ferma il motore.`,
        ns: `Da verificare. Vale la pena sapere quanto del tuo marketing potresti riprendere in mano domani mattina.`
      }
    }
  };

  const baseQuestions    = [Q.f1, Q.f2, Q.tracking, Q.customerCost];
  const foundationEnding = [Q.conversion, Q.ownership];
  const hardEnding       = [Q.nextLever, Q.dependency];

  const TOTAL = 6;

  /* answer value → receipt badge kind + short printed label */
  const ESITO = {
    si: { kind: 'ok',     short: 'Ok' },
    no: { kind: 'open',   short: 'Aperto' },
    ns: { kind: 'verify', short: 'Da verif.' }
  };

  /* ========================================================
     SEVERITY BLOCKS — the verdict (eyebrow + title + body + tier),
     picked by how many points are open. dataTier maps to the
     eyebrow colour scale (1 green · 3 ink · 4 coral).
     Posture (the close) is computed separately, see computePosture.
     ======================================================== */
  const SEVERITY = {
    solida: {
      dataTier: '1', label: 'base solida',
      eyebrow: 'Diagnosi · base solida',
      title: `La base c'è. Ora conta <em>cosa vale soldi per primo</em>.`,
      body: `Risposte solide non vuol dire "niente da fare". Vuol dire che il lavoro giusto non è riparare a caso: è scegliere con precisione dove intervenire senza rompere ciò che già funziona.`
    },
    misto: {
      dataTier: '3', label: 'sistema misto',
      eyebrow: 'Diagnosi · sistema misto',
      title: `Qualcosa funziona.<br>Alcuni punti restano <em>aperti</em>.`,
      body: `Non è tutto da rifare. Bene. Ma ci sono aree che possono costarti soldi ogni settimana, e finché restano aperte lavori con un freno tirato.`
    },
    sistemare: {
      dataTier: '4', label: 'base da sistemare',
      eyebrow: 'Diagnosi · base da sistemare',
      title: `Il sistema <em>perde pezzi</em>.`,
      body: `Qui non serve "fare marketing più forte". Prima bisogna capire dove si stanno perdendo dati, clienti, ordini o decisioni: spingere su un secchio bucato costa e basta.`
    }
  };

  /* ========================================================
     STATE
     ======================================================== */
  const state = {
    current: 0,
    answers: [],                                   // [{ q, key, label, pretty, value, tag, esitoKind, esitoShort, feedback, pillar }]
    questions: baseQuestions.concat(foundationEnding),
    useHard: false,
    startTime: null,
    finalTime: null,
    result: null                                   // { tier, label, posture, durata } — stashed at end for the email payload
  };

  /* ========================================================
     DOM REFS
     ======================================================== */
  const $ = (id) => document.getElementById(id);
  let root, dom, BOOKING_URL, WHATSAPP_URL, EMAIL, docBound = false;

  /* (re)bind every DOM ref — runs on first load AND on shopify:section:load,
     so the live preview keeps working after a theme-editor edit. */
  function grab(){
    root = $('quiz') || document.querySelector('.diag-app');
    BOOKING_URL  = (root && root.dataset.booking)  || '#prenota';
    WHATSAPP_URL = (root && root.dataset.whatsapp) || '#whatsapp';
    EMAIL        = (root && root.dataset.email)    || '#email';
    dom = {
    hero:        $('dx-hero'),
    qmoment:     $('dx-qmoment'),
    qN:          $('dx-q-n'),
    qText:       $('dx-q-text'),
    qSub:        $('dx-q-sub'),
    progress:    $('dx-progress'),
    answers:     document.querySelectorAll('.dx__a'),

    end:         $('dx-end'),
    endEyebrow:  $('dx-end-eyebrow'),
    endEyebrowText: $('dx-end-eyebrow-text'),
    endTitle:    $('dx-end-title'),
    endSub:      $('dx-end-sub'),
    endDur:      $('dx-end-dur'),
    endNote:     $('dx-end-note'),
    endCta:      $('dx-end-cta'),
    endCtaLabel: $('dx-end-cta-label'),
    endCtaBody:  $('dx-end-cta-body'),
    endWa:       $('dx-end-wa'),
    endEmail:    $('dx-end-email'),
    endAlt:      $('dx-end-alt'),
    endPrint:    $('dx-end-print'),
    endSummary:  $('dx-end-summary'),
    endRestart:  $('dx-end-restart'),

    receipt:     $('dx-receipt'),
    quizSlot:    $('dx-quiz-receipt-slot'),
    endSlot:     $('dx-end-receipt-slot'),
    rcptLines:   $('rcpt-lines'),
    rcptDate:    $('rcpt-date'),
    rcptOk:      $('rcpt-total-ok'),
    rcptBad:     $('rcpt-total-bad'),
    rcptVerify:  $('rcpt-total-verify'),
    rcptVerifyWrap: $('rcpt-verify-wrap'),
    rcptTotalR:  $('rcpt-total-r'),
    rcptRestart: $('rcpt-restart'),
    rcptPrint:   $('rcpt-print'),

    strip:       $('dx-strip'),
    stripLine:   $('dx-strip-line'),
    stripToggle: $('dx-strip-toggle'),
    sheetClose:  $('dx-sheet-close'),
    backdrop:    $('dx-sheet-backdrop'),
    };
  }

  /* ========================================================
     INIT
     ======================================================== */
  function init(){
    grab();
    if (!root || !dom.qText) return;
    state.current = 0; state.answers = []; state.finalTime = null; state.useHard = false;
    state.questions = baseQuestions.concat(foundationEnding);
    const now = new Date();
    const dd = String(now.getDate()).padStart(2,'0');
    const mm = String(now.getMonth()+1).padStart(2,'0');
    const hh = String(now.getHours()).padStart(2,'0');
    const mn = String(now.getMinutes()).padStart(2,'0');
    if (dom.rcptDate) dom.rcptDate.textContent = `${dd}/${mm} · ${hh}:${mn}`;

    /* wire the one action to the real booking link */
    if (dom.endCta) {
      dom.endCta.setAttribute('href', BOOKING_URL);
      if (!/^#/.test(BOOKING_URL)) {
        dom.endCta.setAttribute('target', '_blank');
        dom.endCta.setAttribute('rel', 'noopener');
      }
    }

    /* quieter ladder beneath: WhatsApp + email for the not-yet-ready */
    if (dom.endWa) {
      dom.endWa.setAttribute('href', WHATSAPP_URL);
      if (!/^#|^mailto:/.test(WHATSAPP_URL)) { dom.endWa.target = '_blank'; dom.endWa.rel = 'noopener'; }
    }
    if (dom.endEmail) dom.endEmail.setAttribute('href', EMAIL);

    dom.answers.forEach(btn => {
      btn.addEventListener('click', () => handleAnswer(btn.dataset.answer));
    });

    if (!docBound){
      document.addEventListener('keydown', (e) => {
        if (state.current >= TOTAL) return;
        if (e.key === '1') handleAnswer('si');
        if (e.key === '2') handleAnswer('no');
        if (e.key === '3') handleAnswer('ns');
        if (e.key === 'Escape') closeSheet();
      });
      docBound = true;
    }

    if (dom.endRestart) dom.endRestart.addEventListener('click', restart);
    if (dom.endPrint)   dom.endPrint.addEventListener('click', () => window.print());
    if (dom.rcptRestart) dom.rcptRestart.addEventListener('click', restart);
    if (dom.rcptPrint)   dom.rcptPrint.addEventListener('click', () => window.print());
    if (dom.stripToggle) dom.stripToggle.addEventListener('click', openSheet);
    if (dom.sheetClose)  dom.sheetClose.addEventListener('click', closeSheet);
    if (dom.backdrop)    dom.backdrop.addEventListener('click', closeSheet);

    /* GA4 click hooks on the end-screen buttons (booking stays the priority signal) */
    if (dom.endCta)     dom.endCta.addEventListener('click', () => ga('diag_book_call_click', endCtx()));
    if (dom.endWa)      dom.endWa.addEventListener('click', () => ga('diag_whatsapp_click', endCtx()));
    if (dom.endEmail)   dom.endEmail.addEventListener('click', () => ga('diag_email_mailto_click', endCtx()));
    if (dom.endPrint)   dom.endPrint.addEventListener('click', () => ga('diag_print_click', endCtx()));
    if (dom.endRestart) dom.endRestart.addEventListener('click', () => ga('diag_restart_click', endCtx()));

    /* email-capture card on the result screen (self-contained) */
    initCapture(root);

    /* expand / collapse the result rows on the end screen */
    if (dom.rcptLines){
      dom.rcptLines.addEventListener('click', (e) => {
        const row = e.target.closest('.rcpt__line-row');
        if (!row || !dom.rcptLines.contains(row)) return;
        const li = row.closest('.rcpt__line');
        const why = li && li.querySelector('.rcpt__line-why');
        if (!why) return;
        const open = li.classList.toggle('rcpt__line--open');
        why.hidden = !open;
        row.setAttribute('aria-expanded', open ? 'true' : 'false');
        const ind = row.querySelector('.rcpt__line-ind');
        if (ind) ind.textContent = open ? '−' : '+';
      });
    }

    wireSwipe();
    startTimer();
    updateStrip();
    render();
  }

  /* ========================================================
     TIMER — runs silently, surfaced only on the result screen
     ======================================================== */
  function startTimer(){ state.startTime = Date.now(); state.finalTime = null; }
  function stopTimer(){ state.finalTime = formatTime(Date.now() - state.startTime); }
  function formatTime(ms){
    const s = Math.floor(ms / 1000);
    const mm = String(Math.floor(s / 60)).padStart(2,'0');
    const ss = String(s % 60).padStart(2,'0');
    return `${mm}:${ss}`;
  }

  /* ========================================================
     DYNAMIC TRACK — decided once, after the core 4.
     HARD (confident) finish needs BOTH pillars green
     (Q1 visibilità + Q3 tracking) AND ≥3 of the core 4 = Sì.
     ======================================================== */
  function shouldUseHardTrack(){
    const core = state.answers.slice(0, 4);
    const yesCount = core.filter(a => a.value === 'si').length;
    const f1Ok = state.answers[0].value === 'si';   // pillar · visibilità organica
    const s2Ok = state.answers[2].value === 'si';   // pillar · tracking
    return f1Ok && s2Ok && yesCount >= 3;
  }

  /* ========================================================
     ANSWER HANDLING
     ======================================================== */
  function handleAnswer(value){
    if (state.current >= TOTAL) return;

    const q = state.questions[state.current];
    const e = ESITO[value];

    state.answers.push({
      q: state.current,
      key: q.key,
      label: q.label,
      pretty: q.pretty,
      value: value,
      tag: q.tags[value],
      esitoKind: e.kind,
      esitoShort: e.short,
      feedback: q.feedback[value],
      pillar: !!q.pillar,
    });

    state.current += 1;

    if (state.answers.length === 1) ga('quiz_start', {});
    /* per-answer: distribution (what problems people have) + drop-off (step) */
    ga('quiz_answer', {
      step: state.answers.length,   // 1..6
      question: q.key,              // stable id, e.g. "attribuzione"
      answer: value,                // si | no | ns
      esito: e.kind,                // ok | aperto | verifica
      pillar: !!q.pillar            // attribution/tracking pillar question?
    });

    /* lock the dynamic track once the core 4 are in */
    if (state.current === 4) {
      state.useHard = shouldUseHardTrack();
      state.questions = baseQuestions.concat(state.useHard ? hardEnding : foundationEnding);
    }

    appendReceiptLine(state.answers[state.answers.length - 1]);
    updateStrip();

    if (state.current >= TOTAL) {
      stopTimer();
      renderEnd();
    } else {
      render();
    }
  }

  /* ========================================================
     RENDER — question screen (intro = Q1, zero answers)
     ======================================================== */
  function render(){
    const idx = state.current;
    const q = state.questions[idx];
    const answered = state.answers.length;
    const isIntro = idx === 0 && answered === 0;

    root.classList.toggle('is-intro', isIntro);
    root.classList.remove('is-ended');

    if (dom.hero) dom.hero.hidden = !isIntro;

    /* progress dots — done up to `answered`, current dot is `answered` */
    if (dom.progress){
      [...dom.progress.children].forEach((dot, i) => {
        dot.className = i < answered ? 'is-done' : (i === answered ? 'is-now' : '');
      });
    }

    dom.qN.textContent = String(idx + 1).padStart(2,'0');
    dom.qText.innerHTML = q.text;
    dom.qSub.innerHTML = q.sub;

    dom.qmoment.classList.remove('is-changing');
    void dom.qmoment.offsetWidth;
    dom.qmoment.classList.add('is-changing');
  }

  /* ========================================================
     STRIP — mobile sticky receipt counter
     ======================================================== */
  function updateStrip(){
    if (!dom.stripLine) return;
    const n = state.answers.length;
    dom.stripLine.innerHTML =
      `<span class="dx__strip-count">` +
        `<span class="now">${String(n).padStart(2,'0')}</span>` +
        `<span class="sep">/</span><span class="tot">06</span>` +
      `</span>` +
      `<span class="dx__strip-state">${n === 0 ? 'in attesa…' : 'in stampa…'}</span>`;
    dom.stripLine.classList.remove('is-fresh');
    void dom.stripLine.offsetWidth;
    dom.stripLine.classList.add('is-fresh');
  }

  /* ========================================================
     RECEIPT — print a fresh line as each answer lands
     ======================================================== */
  function appendReceiptLine(answer){
    const empty = dom.rcptLines.querySelector('.rcpt__empty');
    if (empty) empty.remove();

    dom.rcptLines.querySelectorAll('.rcpt__line--fresh').forEach(el => {
      el.classList.remove('rcpt__line--fresh');
    });

    const li = document.createElement('li');
    li.className = 'rcpt__line rcpt__line--print rcpt__line--fresh';
    li.innerHTML =
      `<span class="rcpt__line-ix">${String(answer.q + 1).padStart(2,'0')}.</span>` +
      `<span class="rcpt__line-voce">${answer.pretty}</span>` +
      `<span class="rcpt__line-leader" aria-hidden="true"></span>` +
      `<span class="rcpt__esito rcpt__esito--${answer.esitoKind}">${answer.esitoShort}</span>`;
    dom.rcptLines.appendChild(li);
  }

  /* ========================================================
     END STATE — adaptive verdict, always routes to a call
     ======================================================== */
  /* SEVERITY — counts all 6 opens, picks the verdict block */
  function computeSeverity(){
    const a = state.answers;
    const open = a.filter(x => x.value !== 'si').length;       // no + ns
    const pillarOpen = a.some(x => x.pillar && x.value !== 'si');
    if (open === 0) return 'solida';
    if (open >= 4) return 'sistemare';
    /* 1–3 open: a pillar still open with ≥3 opens forces the worst verdict */
    if (pillarOpen && open >= 3) return 'sistemare';
    return 'misto';
  }

  /* POSTURE — the SHAPE of the opens, picks the close block (note + CTA) */
  function computePosture(){
    const a = state.answers;
    const open = a.filter(x => x.value !== 'si');
    const openCount = open.length;
    const noCount = a.filter(x => x.value === 'no').length;
    const nsCount = a.filter(x => x.value === 'ns').length;
    /* CONFIDENT — reached the hard finish, or barely anything open */
    if (state.useHard || openCount <= 1){
      return openCount === 0 ? 'confident_green' : 'confident_open';
    }
    /* openCount >= 2 */
    if (noCount > nsCount) return 'aware';
    /* ns >= no (ties → fog); split on whether ANY open is a "no" */
    return open.every(x => x.value === 'ns') ? 'fog_ns' : 'fog_mixed';
  }

  /* summary line — exact count, never hides an item (1–4 enumerated) */
  function summaryHTML(){
    const open = state.answers.filter(a => a.value !== 'si');
    const n = open.length;
    if (n === 0){
      return `<em>Tutto in ordine.</em> Niente fuoco da spegnere: un sistema che lavora per te.`;
    }
    if (n >= 5){
      return `<em>Diversi punti aperti.</em> La buona notizia: basta sistemarne uno bene per spostare i numeri.`;
    }
    const names = open.map(a => `<strong>${a.pretty}</strong>`);
    const list = names.length === 1
      ? names[0]
      : names.slice(0, -1).join(', ') + ' e ' + names[names.length - 1];
    const lead = n === 1 ? '1 voce da guardare' : `${n} voci da guardare`;
    return `<em>${lead}</em>: ${list}. Tutto il resto regge bene.`;
  }

  function renderEnd(){
    if (dom.end) dom.end.hidden = false;
    root.classList.add('is-ended');
    root.classList.remove('is-intro');
    closeSheet();

    /* move the live receipt into the results layout */
    if (dom.receipt && dom.endSlot) dom.endSlot.appendChild(dom.receipt);

    /* ---- VERDICT (severity) — eyebrow + title + body + colour tier ---- */
    const sev = SEVERITY[computeSeverity()];
    if (dom.endEyebrow)     dom.endEyebrow.setAttribute('data-tier', sev.dataTier);
    if (dom.endEyebrowText) dom.endEyebrowText.textContent = sev.eyebrow;
    if (dom.endTitle)       dom.endTitle.innerHTML = sev.title;
    if (dom.endSub)         dom.endSub.innerHTML = sev.body;
    if (dom.endDur)         dom.endDur.textContent = state.finalTime || '00:00';
    if (dom.endSummary)     dom.endSummary.innerHTML = summaryHTML();

    /* ---- CLOSE (posture) — note + CTA only, separate from the verdict ---- */
    const openTotal = state.answers.filter(a => a.value !== 'si').length;
    const posture = computePosture();
    let note, ctaLabel, ctaBody, soft = false;
    switch (posture){
      case 'confident_green':
        note = 'Sei nel 5%';
        ctaLabel = 'Base a posto sul serio. Parliamo della prossima mossa.';
        ctaBody = 'Onestamente, poco da sistemare. Il valore qui è decidere la prossima leva coi numeri, non a sentimento. Facciamo 15 minuti e guardiamo dove conviene spingere.';
        soft = true;   /* clean result → quiet outline CTA, no hard sell */
        break;
      case 'confident_open':
        note = 'Sei messo bene';
        ctaLabel = 'Hai una base rara. Troviamo insieme la leva che vale di più.';
        ctaBody = 'Niente da spegnere di urgente. La call di 15 minuti è un confronto pratico: guardiamo dove conviene spingere, coi tuoi numeri.';
        break;
      case 'aware':
        note = 'Sai già dove guardare';
        ctaLabel = `Hai ${openTotal} punti aperti, e sai quali sono. Sistemiamoli.`;
        ctaBody = 'Non ti serve qualcuno che ti dica cosa è rotto: lo sai già. Ti serve qualcuno che lo sistemi. La call di 15 minuti parte da lì.';
        break;
      case 'fog_ns':
        note = 'Il prossimo passo';
        ctaLabel = `${openTotal} "non so", ed è la risposta giusta. Guardiamoli insieme.`;
        ctaBody = 'Non devi avere le risposte: è esattamente per questo che esistono i 15 minuti. Nessun compito da fare prima: solo qualcuno che guarda i tuoi numeri con te.';
        break;
      default: /* fog_mixed */
        note = 'Il prossimo passo';
        ctaLabel = `${openTotal} punti da chiarire, e non devi risolverli da solo. Guardiamoli insieme.`;
        ctaBody = 'Non devi avere le risposte: è esattamente per questo che esistono i 15 minuti. Nessun compito da fare prima: solo qualcuno che guarda i tuoi numeri con te.';
        break;
    }
    if (dom.endNote)     dom.endNote.textContent = note;
    if (dom.endCtaLabel) dom.endCtaLabel.textContent = ctaLabel;
    if (dom.endCtaBody)  dom.endCtaBody.textContent = ctaBody;
    if (dom.endCta) dom.endCta.classList.toggle('dx__end-cta--soft', soft);

    /* rebuild the receipt lines as expandable result rows */
    dom.rcptLines.innerHTML = '';
    state.answers.forEach(a => {
      const li = document.createElement('li');
      li.className = 'rcpt__line rcpt__line--result';
      li.innerHTML =
        `<button class="rcpt__line-row" type="button" aria-expanded="false">` +
          `<span class="rcpt__line-ix">${String(a.q + 1).padStart(2,'0')}.</span>` +
          `<span class="rcpt__line-voce">${a.pretty}</span>` +
          `<span class="rcpt__line-leader" aria-hidden="true"></span>` +
          `<span class="rcpt__esito rcpt__esito--${a.esitoKind}">${a.tag}</span>` +
          `<span class="rcpt__line-ind" aria-hidden="true">+</span>` +
        `</button>` +
        `<div class="rcpt__line-why" hidden>` +
          `<span class="rcpt__line-why-lbl">Perché conta</span>` +
          `<p class="rcpt__line-why-txt">${a.feedback}</p>` +
        `</div>`;
      dom.rcptLines.appendChild(li);
    });

    /* receipt total */
    const ok     = state.answers.filter(a => a.value === 'si').length;
    const open   = state.answers.filter(a => a.value === 'no').length;
    const verify = state.answers.filter(a => a.value === 'ns').length;
    if (dom.rcptOk)     dom.rcptOk.textContent = ok;
    if (dom.rcptBad)    dom.rcptBad.textContent = open;
    if (dom.rcptVerify) dom.rcptVerify.textContent = verify;
    if (dom.rcptVerifyWrap) dom.rcptVerifyWrap.hidden = verify === 0;
    if (dom.rcptTotalR) dom.rcptTotalR.textContent = `${state.answers.length}/${TOTAL}`;

    /* ---- stash the result for the email payload + fire the GA completion event ---- */
    state.result = {
      tier:    sev.dataTier,
      label:   sev.label,
      posture: posture,
      durata:  state.finalTime || '00:00'
    };
    ga('diag_completed', {
      tier: sev.dataTier, posture: posture,
      punti_aperti: open, da_verificare: verify, ok: ok,
      track: state.useHard ? 'hard' : 'foundation'
    });
  }

  /* ========================================================
     EMAIL CAPTURE + TRACKING (self-contained) — see the matching
     HTML (#dx-cap) + CSS (.dx__cap) blocks. Lift these three blocks
     together to move the whole feature to a standalone page.
     · GA4: gtag → dataLayer → no-op, never throws.
     · Klaviyo: client-side fetch (Create Client Event always;
       Create Client Subscription only with marketing consent).
       Keys come from data-klaviyo-key / -list on .diag-app.
     ======================================================== */
  function ga(name, params){
    params = params || {};
    try {
      // Route through the shared tracker (publishes to Shopify Customer Events →
      // the GA4 Custom Pixel, and mirrors to dataLayer). Fall back to gtag/dataLayer.
      if (typeof window.carliosTrack === 'function') { window.carliosTrack(name, params); return; }
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
      else if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, params));
    } catch(e){}
  }
  /* small context for the end-button GA clicks */
  function endCtx(){ const r = state.result || {}; return { tier: r.tier, posture: r.posture }; }

  /* the data the Klaviyo email template loops over to rebuild the scontrino */
  function buildResultPayload(){
    const ok     = state.answers.filter(a => a.value === 'si').length;
    const open   = state.answers.filter(a => a.value === 'no').length;
    const verify = state.answers.filter(a => a.value === 'ns').length;
    const r = state.result || {};
    return {
      diagnosi_tier:  r.tier  || '',
      diagnosi_label: r.label || '',
      posture:        r.posture || '',
      durata:         r.durata || (state.finalTime || '00:00'),
      ok: ok, punti_aperti: open, da_verificare: verify,
      voci: state.answers.map(function(a, i){
        return { n: i + 1, voce: a.pretty, esito: a.esitoKind, tag: a.tag };
      })
    };
  }

  /* Klaviyo Client APIs (public key only, browser-safe). revision pinned to a
     current date; verify against Klaviyo docs if requests start 4xx-ing. */
  function sendToKlaviyo(email, marketing, payload){
    try {
      const key  = (root && root.dataset.klaviyoKey)  || '';
      const list = (root && root.dataset.klaviyoList) || '';
      if (!key) return;                              // not configured → no-op (safe to ship before keys exist)
      const REV = '2026-04-15';

      /* 1) ALWAYS — custom event that triggers the HTML-receipt flow in Klaviyo */
      fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': REV },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              properties: payload,
              metric:  { data: { type: 'metric',  attributes: { name: 'Completed Diagnostica' } } },
              profile: { data: { type: 'profile', attributes: { email: email } } }
            }
          }
        })
      }).catch(function(){});

      /* 2) ONLY WITH CONSENT — subscribe to the marketing list (records consent) */
      if (marketing && list) {
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': REV },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: {
                  email: email,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                } } }
              },
              relationships: { list: { data: { type: 'list', id: list } } }
            }
          })
        }).catch(function(){});
      }
    } catch(e){ /* never block the UI on a tracking failure */ }
  }

  function initCapture(scope){
    const box = scope.querySelector('#dx-cap');
    if (!box || box.dataset.bound) return;           // bind once per (re)rendered section
    box.dataset.bound = '1';
    const input   = box.querySelector('#dx-cap-email');
    const submit  = box.querySelector('#dx-cap-submit');
    const consent = box.querySelector('#dx-cap-consent');
    const status  = box.querySelector('#dx-cap-status');
    if (!input || !submit) return;
    let sent = false;
    const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    function say(msg, ok){
      status.hidden = false;
      status.textContent = msg;
      status.classList.toggle('is-ok', !!ok);
      status.classList.toggle('is-err', !ok);
    }
    function handle(){
      if (sent) return;
      const email = (input.value || '').trim();
      if (!EMAIL_RE.test(email)){ say("Controlla l'indirizzo e riprova.", false); input.focus(); return; }
      const payload = buildResultPayload();
      const marketing = !!(consent && consent.checked);
      submit.disabled = true;
      sendToKlaviyo(email, marketing, payload);
      ga('diag_email_capture', { marketing: marketing, tier: payload.diagnosi_tier, punti_aperti: payload.punti_aperti });
      sent = true;
      say('Fatto: controlla la posta. L’ho mandato a ' + email + '.', true);
      input.disabled = true;
      if (consent) consent.disabled = true;
    }
    submit.addEventListener('click', handle);
    input.addEventListener('keydown', function(e){ if (e.key === 'Enter'){ e.preventDefault(); handle(); }});
  }

  /* ========================================================
     SHEET — mobile slide-up receipt
     ======================================================== */
  function isMobile(){ return window.matchMedia('(max-width: 900px)').matches; }
  function openSheet(){
    if (isMobile() && !root.classList.contains('is-ended')){
      root.classList.add('sheet-open');
    }
  }
  function closeSheet(){ root.classList.remove('sheet-open'); }

  function wireSwipe(){
    if (!dom.receipt) return;
    let y0 = null;
    dom.receipt.addEventListener('touchstart', (e) => {
      y0 = root.classList.contains('sheet-open') ? e.touches[0].clientY : null;
    }, { passive:true });
    dom.receipt.addEventListener('touchmove', (e) => {
      if (y0 == null) return;
      if (e.touches[0].clientY - y0 > 70){ closeSheet(); y0 = null; }
    }, { passive:true });
    dom.receipt.addEventListener('touchend', () => { y0 = null; });
  }

  /* ========================================================
     RESTART — full reset, including the dynamic track
     ======================================================== */
  function restart(){
    state.current = 0;
    state.answers = [];
    state.finalTime = null;
    state.useHard = false;
    state.questions = baseQuestions.concat(foundationEnding);

    root.classList.remove('is-ended', 'sheet-open');

    /* move the receipt back into the quiz layout */
    if (dom.receipt && dom.quizSlot) dom.quizSlot.appendChild(dom.receipt);

    /* reset the receipt to its empty state */
    dom.rcptLines.innerHTML =
      `<li class="rcpt__empty">` +
        `<span class="rcpt__empty-count"><span class="now">00</span><span class="sep">/</span><span class="tot">06</span></span>` +
        `<span class="rcpt__empty-lbl">in attesa di risposte</span>` +
        `<span class="rcpt__empty-hint">lo scontrino si stampa<br>mentre rispondi</span>` +
      `</li>`;

    if (dom.end) dom.end.hidden = true;

    startTimer();
    updateStrip();
    render();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function(e){
    if (!e.target || !e.target.querySelector || e.target.querySelector('.diag-app')) init();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carlios-domande"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initFaq(root){
    if(!root || root.dataset.faqReady === '1') return;
    var items = Array.prototype.slice.call(root.querySelectorAll('.qa-list .qa'));
    if(!items.length){ return; }
    root.dataset.faqReady = '1';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var DUR = 460; // a touch past the CSS .42s, as a fallback
    function panel(d){ return d.querySelector('.qa__panel'); }
    function openItem(d){
      var p = panel(d); d.open = true;
      if(reduce){ p.style.height = 'auto'; return; }
      p.style.height = '0px'; void p.offsetHeight;
      p.style.height = p.firstElementChild.offsetHeight + 'px';
      var done = false;
      var fin = function(){ if(done) return; done = true; if(d.open) p.style.height = 'auto'; p.removeEventListener('transitionend', on); };
      var on = function(e){ if(e.propertyName === 'height') fin(); };
      p.addEventListener('transitionend', on); setTimeout(fin, DUR + 60);
    }
    function closeItem(d){
      var p = panel(d);
      if(reduce){ d.open = false; p.style.height = ''; return; }
      p.style.height = p.firstElementChild.offsetHeight + 'px'; void p.offsetHeight;
      p.style.height = '0px';
      var done = false;
      var fin = function(){ if(done) return; done = true; d.open = false; p.removeEventListener('transitionend', on); };
      var on = function(e){ if(e.propertyName === 'height') fin(); };
      p.addEventListener('transitionend', on); setTimeout(fin, DUR + 60);
    }
    items.forEach(function(d){
      if(d.open && !reduce){ panel(d).style.height = 'auto'; }
      d.querySelector('.qa__head').addEventListener('click', function(e){
        e.preventDefault();
        d.open ? closeItem(d) : openItem(d);
      });
    });
    var t;
    window.addEventListener('resize', function(){
      clearTimeout(t);
      t = setTimeout(function(){ items.forEach(function(d){ if(d.open && !reduce){ panel(d).style.height = 'auto'; } }); }, 150);
    });
  }
  function boot(){ Array.prototype.slice.call(document.querySelectorAll('.carlios-domande')).forEach(initFaq); }
  if(document.readyState !== 'loading'){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
  document.addEventListener('shopify:section:load', function(e){
    var el = e.target && e.target.querySelector ? e.target.querySelector('.carlios-domande') : null;
    if(el){ el.dataset.faqReady = ''; initFaq(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carlios-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(nav){
    if(!nav || nav.dataset.navInit) return;
    nav.dataset.navInit = "1";
    // language switcher: native <select> submits the localization form on change
    var langSel = nav.querySelector("[data-lang-select]");
    if(langSel){ langSel.addEventListener("change", function(){ if(langSel.form){ langSel.form.submit(); } }); }
    var btn = nav.querySelector("[data-nav-toggle]");
    var panel = nav.querySelector("[data-nav-panel]");
    if(!btn || !panel) return;
    function setOpen(open){
      nav.classList.toggle("nav-open", open);
      btn.setAttribute("aria-expanded", open ? "true" : "false");
      btn.setAttribute("aria-label", open ? "Chiudi il menu" : "Apri il menu");
    }
    btn.addEventListener("click", function(){ setOpen(!nav.classList.contains("nav-open")); });
    panel.addEventListener("click", function(e){ if(e.target.closest("a")) setOpen(false); });
    document.addEventListener("keydown", function(e){ if(e.key === "Escape") setOpen(false); });
  }
  function boot(){ document.querySelectorAll("[data-nav]").forEach(init); }
  if(document.readyState === "loading"){ document.addEventListener("DOMContentLoaded", boot); } else { boot(); }
  document.addEventListener("shopify:section:load", boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carlios-lavori"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.dataset.lvInit) return;
    root.dataset.lvInit = "1";
    var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;

    // LIO's face = the active case's expression (set on tab select / accordion open).
    var lioSun = root.querySelector(".lv-prompt__sun");
    var sunUse = lioSun ? lioSun.querySelector("use") : null;
    var lioFaces = ["puzzled","overwhelmed","worried","frazzled","buried"];
    function setFace(i){ if(sunUse && lioFaces[i]) sunUse.setAttribute("href", "#carlios-lv-sun-" + lioFaces[i]); }

    function reveal(scope){
      if(reduce) return;
      var st = scope && scope.querySelector(".stage");
      if(!st) return;
      st.classList.add("anim");
      void st.offsetWidth;
      setTimeout(function(){ st.classList.remove("anim"); }, 40);
    }

    var viewer = root.querySelector(".lv-viewer");
    var tabs = Array.prototype.slice.call(root.querySelectorAll(".selector .tab"));
    var panels = viewer ? Array.prototype.slice.call(viewer.querySelectorAll(".feat")) : [];
    if(viewer && tabs.length && panels.length){
      viewer.classList.add("has-js");
      var cur = -1;
      function select(i){
        if(i === cur || !panels[i]) return;
        tabs.forEach(function(t,k){ t.setAttribute("aria-selected", k===i ? "true" : "false"); });
        panels.forEach(function(p,k){ p.classList.toggle("is-active", k===i); });
        reveal(panels[i]);
        setFace(i);
        cur = i;
      }
      tabs.forEach(function(t,k){
        t.addEventListener("click", function(){ select(k); });
        t.addEventListener("keydown", function(e){
          var ni = null;
          if(e.key==="ArrowRight" || e.key==="ArrowDown") ni = (k+1) % tabs.length;
          if(e.key==="ArrowLeft"  || e.key==="ArrowUp")   ni = (k-1+tabs.length) % tabs.length;
          if(ni !== null){ e.preventDefault(); tabs[ni].focus(); select(ni); }
        });
      });
      select(0);
    }

    var acc = root.querySelector(".lv-acc");
    if(acc){
      acc.classList.add("has-js");
      var items = Array.prototype.slice.call(acc.querySelectorAll(".acc"));
      // Scroll the opened item's header to the top AFTER the expand/collapse
      // settles, so the final position is stable (no jump to the wrong place).
      function scrollToItem(it){
        if(!it.offsetParent) return;            // only when the accordion is visible (mobile)
        var hd = it.querySelector(".acc__hd");
        var body = it.querySelector(".acc__body");
        var off = 14, done = false;
        function go(){
          if(done) return; done = true;
          if(body) body.removeEventListener("transitionend", onEnd);
          var y = window.pageYOffset + hd.getBoundingClientRect().top - off;
          window.scrollTo({ top: y, behavior: reduce ? "auto" : "smooth" });
        }
        function onEnd(e){ if(e.propertyName === "grid-template-rows") go(); }
        if(body) body.addEventListener("transitionend", onEnd);
        setTimeout(go, 440);                     // fallback if transitionend doesn't fire
      }
      items.forEach(function(it, idx){
        var hd = it.querySelector(".acc__hd");
        hd.addEventListener("click", function(){
          var wasOpen = it.classList.contains("acc--open");
          items.forEach(function(o){ o.classList.remove("acc--open"); o.querySelector(".acc__hd").setAttribute("aria-expanded","false"); });
          if(!wasOpen){ it.classList.add("acc--open"); hd.setAttribute("aria-expanded","true"); reveal(it); scrollToItem(it); setFace(idx); }
        });
      });
      if(items[0]){ items[0].classList.add("acc--open"); items[0].querySelector(".acc__hd").setAttribute("aria-expanded","true"); reveal(items[0]); setFace(0); }
    }
  }

  function boot(){ document.querySelectorAll(".carlios-lavori").forEach(init); }
  if(document.readyState !== "loading") boot(); else document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", function(e){
    var el = e.target && e.target.querySelector && e.target.querySelector(".carlios-lavori");
    if(el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carlios-recensioni"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initRec(root){
    if(!root || root.dataset.recReady === '1') return;
    root.dataset.recReady = '1';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var stages = Array.prototype.slice.call(root.querySelectorAll('.vr-stage'));

    function hydrate(v){ if(v.dataset.hydrated) return; if(v.dataset.src){ v.src = v.dataset.src; v.load(); } v.dataset.hydrated = '1'; }

    stages.forEach(function(stage){
      var v = stage.querySelector('video');
      var playBtn = stage.querySelector('.vr-play');
      var muteBtn = stage.querySelector('.vr-mute');
      var fill = stage.querySelector('.vr-bar__fill');
      if(!v) return;
      function applyMute(){ stage.classList.toggle('is-muted', v.muted); }
      applyMute();
      function start(){
        stages.forEach(function(o){ if(o !== stage){ var ov = o.querySelector('video'); if(ov && !ov.paused){ ov.pause(); } o.classList.remove('is-playing'); } });
        hydrate(v);
        if(!v.dataset.src) return; /* no video set yet — nothing to play */
        v.muted = true; applyMute();
        stage.classList.remove('watched'); stage.classList.add('started');
        var p = v.play(); if(p && p.catch){ p.catch(function(){}); }
      }
      function stop(){ v.pause(); }
      if(playBtn) playBtn.addEventListener('click', function(e){ e.stopPropagation(); if(v.paused){ start(); } else { stop(); } });
      if(muteBtn) muteBtn.addEventListener('click', function(e){ e.stopPropagation(); v.muted = !v.muted; applyMute(); });
      stage.addEventListener('click', function(){ if(v.paused){ start(); } else { stop(); } });
      v.addEventListener('play',  function(){ stage.classList.add('is-playing','started'); });
      v.addEventListener('pause', function(){ stage.classList.remove('is-playing'); });
      v.addEventListener('ended', function(){ stage.classList.remove('is-playing','started'); stage.classList.add('watched'); try{ v.currentTime = 0; }catch(_){} if(fill) fill.style.width = '0%'; });
      v.addEventListener('timeupdate', function(){ if(fill && v.duration){ fill.style.width = (v.currentTime / v.duration * 100) + '%'; } });
    });

    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ var st = en.target;
          if(en.isIntersecting){ st.classList.add('in-view'); }
          else{ st.classList.remove('in-view'); var vv = st.querySelector('video'); if(vv && !vv.paused){ vv.pause(); } }
        });
      }, { threshold:0.25 });
      stages.forEach(function(s){ io.observe(s); });
    } else { stages.forEach(function(s){ s.classList.add('in-view'); }); }

    /* swipe carousel: wrap each run of consecutive written reviews so they scroll one at a time
       on mobile (stacked is the no-JS default; CSS makes the wrapper transparent on desktop). */
    if(root.classList.contains('rec-swipe')){
      var flow = root.querySelector('.rec-flow');
      if(flow && flow.dataset.swipeBuilt !== '1'){
        flow.dataset.swipeBuilt = '1';
        var run = [];
        var flush = function(){
          if(run.length > 1){
            var wrap = document.createElement('div');
            wrap.className = 'rv-carousel';
            flow.insertBefore(wrap, run[0]);
            run.forEach(function(it){ wrap.appendChild(it); });
            var pager = document.createElement('div');
            pager.className = 'rv-pager';
            var items = run.slice();
            var dots = items.map(function(_, i){
              var d = document.createElement('button');
              d.type = 'button'; d.className = 'rv-dot'; d.setAttribute('aria-label', 'Vai alla recensione ' + (i + 1));
              d.addEventListener('click', function(){ wrap.scrollTo({ left: items[i].offsetLeft, behavior: 'smooth' }); });
              pager.appendChild(d); return d;
            });
            flow.insertBefore(pager, wrap.nextSibling);
            var sync = function(){
              var mid = wrap.scrollLeft + wrap.clientWidth / 2, best = 0, bd = Infinity;
              items.forEach(function(it, i){ var c = it.offsetLeft + it.offsetWidth / 2, dd = Math.abs(c - mid); if(dd < bd){ bd = dd; best = i; } });
              dots.forEach(function(d, i){ d.classList.toggle('is-on', i === best); });
            };
            wrap.addEventListener('scroll', sync, { passive: true });
            sync();
          }
          run = [];
        };
        Array.prototype.slice.call(flow.children).forEach(function(k){
          if(k.classList && k.classList.contains('rv-item')){ run.push(k); } else { flush(); }
        });
        flush();
      }
    }
  }
  function boot(){ Array.prototype.slice.call(document.querySelectorAll('.carlios-rec')).forEach(initRec); }
  if(document.readyState !== 'loading'){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
  document.addEventListener('shopify:section:load', function(e){ var el = e.target && e.target.querySelector ? e.target.querySelector('.carlios-rec') : null; if(el){ el.dataset.recReady = ''; initRec(el); } });
})();

  } catch(e) { console.error(e); }
})();
})();
